import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import TaxonomyManager, { type TaxonomyItem } from '@/components/admin/TaxonomyManager'

type Props = {
  constant_networks: string[]
  pending: TaxonomyItem[]
  official: TaxonomyItem[]
}

export default function AdminProfessionalNetworksIndex({ constant_networks, pending, official }: Props) {
  return (
    <>
      <Head title="Admin - Professional Networks" />
      <TaxonomyManager
        title="Professional Networks"
        description="Manage the official list of professional networks and review pending submissions from users and organizations."
        resourcePath="/admin/professional_networks"
        paramKey="professional_network"
        baseConstants={constant_networks}
        pending={pending}
        official={official}
        addLabel="Add professional network"
        addPlaceholder="e.g., Hospitality"
      />
    </>
  )
}

AdminProfessionalNetworksIndex.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
